@if (isVisible) {
  <div class="growler growler--theme-{{ type }} growler--position-{{ position }}">
    <div class="row">
      <div class="col">
        <div class="growler__message">
          <ng-content></ng-content>
        </div>
      </div>
      <div class="col-auto">
        <div class="growler__undo" role="button">
          <a (click)="onUndo()" (keydown.enter)="onUndo()" tabindex="0">X</a>
        </div>
      </div>
    </div>
  </div>
}
